import React, { useState } from 'react';
import { AlertCircleIcon, CheckCircle2Icon, ClockIcon, LoaderIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/company';
type Status = 'idle' | 'sending' | 'sent' | 'error';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    name: '',
    phone: '',
    city: '',
    need: ''
  });
  const update = (field: keyof typeof form) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(prev => ({
    ...prev,
    [field]: event.target.value
  }));
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setStatus('error');
      return;
    }
    setStatus('sending');
    window.setTimeout(() => setStatus('sent'), 900);
  };
  return <section id="contact" className="bg-ink-900 py-16 text-bone lg:py-24" data-id="element-28" data-mp="giffp4gy2p7v">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-29" data-mp="bouhpcfcpv8o">
        <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-30" data-mp="3jv2uuwrvh61c">
          <div data-id="element-31" data-mp="3jxxfopesssva">
            <h2 className="font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-32" data-mp="3ouefigvd0vo7">
              Une urgence&nbsp;? Appelez.
              <br data-id="element-33" data-mp="3b281p1foj0rx" />
              <span className="text-brass-light" data-id="element-34" data-mp="3b2rey4udx0zm">Un devis&nbsp;? Écrivez.</span>
            </h2>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-ink-500" data-id="element-35" data-mp="3f3bflie62mqi">
              Pour une porte bloquée, le téléphone reste le plus rapide. Pour un blindage, un
              changement de serrure ou une demande de syndic, laissez-moi vos coordonnées&nbsp;: je
              rappelle dans la journée.
            </p>

            <dl className="mt-10 space-y-6" data-id="element-36" data-mp="2s6rjul641hbt">
              <div className="flex gap-4" data-id="element-37" data-mp="2w71ptxtwk7qo">
                <PhoneIcon className="mt-1 h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-38" data-mp="2w7tojhisqll6" />
                <div data-id="element-39" data-mp="qaxp6pxd7fx5">
                  <dt className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-40" data-mp="uenfbjtou5ka">
                    Téléphone
                  </dt>
                  <dd className="mt-1" data-id="element-41" data-mp="23d5b0lkdz68k">
                    <a href={company.phoneHref} className="font-display text-xl font-bold text-bone transition-colors duration-150 ease-out hover:text-brass-light" data-id="element-42" data-mp="1ych9h5yj7703">
                      {company.phone}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-43" data-mp="2m0s7m1cuesko">
                <MailIcon className="mt-1 h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-44" data-mp="2i0glek4u0k73" />
                <div data-id="element-45" data-mp="2i2uguu3fbyf6">
                  <dt className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-46" data-mp="2d98blmzlawte">
                    E-mail
                  </dt>
                  <dd className="mt-1 text-base text-bone-dark" data-id="element-47" data-mp="28aewxr8kgzrn">
                    <a href={`mailto:${company.email}`} className="hover:text-brass-light" data-id="element-48" data-mp="35qavitxrnunn">
                      {company.email}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-49" data-mp="38bsexyp6uhb5">
                <MapPinIcon className="mt-1 h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-50" data-mp="38ctotzugwxra" />
                <div data-id="element-51" data-mp="3dbesk98xhzkh">
                  <dt className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-52" data-mp="3i8wvnj09lkkk">
                    Atelier
                  </dt>
                  <dd className="mt-1 text-base text-bone-dark" data-id="element-53" data-mp="3mbtdh7hzdcng">
                    {company.address}
                    <br data-id="element-54" data-mp="3r9342qh3vucv" />
                    {company.postalCode} {company.city}
                  </dd>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-55" data-mp="4u0edvwzkp1c">
                <ClockIcon className="mt-1 h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-56" data-mp="4ua7vth8pebs" />
                <div data-id="element-57" data-mp="9rjyhcgd7w17">
                  <dt className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-58" data-mp="9uxxcaptln3w">
                    Horaires
                  </dt>
                  <dd className="mt-1 text-base text-bone-dark" data-id="element-59" data-mp="isrufnvesks4">{company.hours}</dd>
                </div>
              </div>
            </dl>
          </div>

          <div className="bg-ink-950 p-7 lg:p-9" data-id="element-60" data-mp="54gae9dt9g61">
            {status === 'sent' ? <div className="flex h-full flex-col items-start justify-center py-10" data-id="element-61" data-mp="134tcs90639g">
                <CheckCircle2Icon className="h-8 w-8 text-brass-light" aria-hidden="true" data-id="element-62" data-mp="ew44ki1r5bb7" />
                <h3 className="mt-5 font-display text-xl font-bold text-bone" data-id="element-63" data-mp="9y2ps9bczy5j">
                  Demande bien reçue, {form.name.split(' ')[0]}.
                </h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-ink-500" data-id="element-64" data-mp="3ec95sd6lyb3n">
                  Je vous rappelle au {form.phone} dans la journée. Si c’est urgent, n’attendez pas
                  et appelez directement le {company.phone}.
                </p>
                <button type="button" onClick={() => {
              setForm({
                name: '',
                phone: '',
                city: '',
                need: ''
              });
              setStatus('idle');
            }} className="mt-7 text-sm font-semibold text-brass-light underline underline-offset-4" data-id="element-65" data-mp="3nes9t0m4qtrh">
                  Envoyer une autre demande
                </button>
              </div> : <form onSubmit={handleSubmit} noValidate data-id="element-66" data-mp="2bk6rsr2o6hkd">
                <h3 className="font-display text-lg font-bold text-bone" data-id="element-67" data-mp="2gi88j5cmi4so">Demander un rappel</h3>
                <div className="mt-6 space-y-5" data-id="element-68" data-mp="2gk2sagc5rqv6">
                  <Field id="name" label="Nom" value={form.name} onChange={update('name')} required autoComplete="name" data-id="element-69" data-mp="348vma797zon5" />
                  <Field id="phone" label="Téléphone" type="tel" value={form.phone} onChange={update('phone')} required autoComplete="tel" data-id="element-70" data-mp="2zguasnjvm1y6" />
                  <Field id="city" label="Commune" value={form.city} onChange={update('city')} autoComplete="address-level2" data-id="element-71" data-mp="5nprg3wbqrkc" />
                  <div data-id="element-72" data-mp="3rtwdkeg2r5nk">
                    <label htmlFor="need" className="block text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-73" data-mp="3rxak7yvru10t">
                      Votre besoin
                    </label>
                    <textarea id="need" rows={4} value={form.need} onChange={update('need')} placeholder="Ex. : changement de cylindre sur porte blindée, 3e étage." className="mt-2 w-full rounded-sm border border-ink-700 bg-ink-900 px-3.5 py-2.5 text-sm text-bone placeholder:text-ink-600 transition-colors duration-150 ease-out focus:border-brass focus:outline-none" data-id="element-74" data-mp="3e3j6eeb0buza" />
                  </div>
                </div>

                {status === 'error' && <p role="alert" className="mt-5 flex items-start gap-2.5 border-l-2 border-alert bg-ink-900 px-3.5 py-3 text-sm text-bone-dark" data-id="element-75" data-mp="1engecceh0esd">
                    <AlertCircleIcon className="mt-0.5 h-4 w-4 flex-none text-alert" aria-hidden="true" data-id="element-76" data-mp="1olcmqwg0wvms" />
                    Merci d’indiquer au moins votre nom et votre téléphone pour que je puisse vous
                    rappeler.
                  </p>}

                <button type="submit" disabled={status === 'sending'} className="mt-7 flex w-full items-center justify-center gap-2.5 rounded-sm bg-brass px-6 py-3.5 font-display text-base font-bold text-ink-950 transition-colors duration-150 ease-out hover:bg-brass-light disabled:cursor-wait disabled:opacity-70" data-id="element-77" data-mp="10wl2qscl7jl3">
                  {status === 'sending' ? <>
                      <LoaderIcon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-78" data-mp="32rokgwy11vqg" />
                      Envoi…
                    </> : 'Être rappelé'}
                </button>
                <p className="mt-4 text-xs leading-relaxed text-ink-600" data-id="element-79" data-mp="36qw8wsadzw22">
                  Vos coordonnées servent uniquement à vous rappeler et ne sont jamais transmises à
                  un tiers.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}
type FieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  required?: boolean;
  autoComplete?: string;
};
function Field({
  id,
  label,
  value,
  onChange,
  type = 'text',
  required,
  autoComplete
}: FieldProps) {
  return <div data-id="element-80" data-mp="3bruyqdk5v7m">
      <label htmlFor={id} className="block text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-81" data-mp="3c08mkhi94jv">
        {label}
        {required && <span className="ml-1 text-brass" data-id="element-82" data-mp="rvv7ehuiyf1k">*</span>}
      </label>
      <input id={id} name={id} type={type} value={value} onChange={onChange} required={required} autoComplete={autoComplete} className="mt-2 w-full rounded-sm border border-ink-700 bg-ink-900 px-3.5 py-2.5 text-sm text-bone transition-colors duration-150 ease-out focus:border-brass focus:outline-none" data-id="element-83" data-mp="rszb0xybryf8" />
    </div>;
}